// WM Shipment Scheduling — Pick Capacity Slots.
// Mirror of Argos.Core/Constants/PickCapacityConstants.cs. The server decides every status and
// action; these only render what it sent.

export const SLOT_STATUS = {
    AVAILABLE: 'Available',
    AT_CAPACITY: 'AtCapacity',
    UNAVAILABLE: 'Unavailable',
};

export const SLOT_STATUS_LABELS = {
    [SLOT_STATUS.AVAILABLE]: 'Available',
    [SLOT_STATUS.AT_CAPACITY]: 'At Capacity',
    [SLOT_STATUS.UNAVAILABLE]: 'Unavailable',
};

export const SLOT_STATUS_CLASS = {
    [SLOT_STATUS.AVAILABLE]: 'pick-capacity-status-available',
    [SLOT_STATUS.AT_CAPACITY]: 'pick-capacity-status-at',
    [SLOT_STATUS.UNAVAILABLE]: 'pick-capacity-status-unavailable',
};

export const SLOT_ACTION = {
    APPLY: 'Apply',
    // The selection does not fit; the user may ask for the slot and a manager decides.
    REQUEST: 'Request',
    NONE: 'None',
};
